<mat-toolbar class="secondary-toolbar mat-elevation-z1">
  <div *ngIf="state!='LIST'" class="secondary-toolbar-item selectable" (click)="showList()"><mat-icon>list</mat-icon> All Accounts</div>
  <ng-container *ngIf="state=='EDIT'">
    <div class="secondary-toolbar-item"><mat-icon svgIcon="cw:action_next"></mat-icon>{{selectedAccount.name}}</div>
  </ng-container>
</mat-toolbar>

<section class="main-content">
  <app-account-list #accountList *ngIf="state=='LIST'"   (stateChange)="onStateChange($event)" [parentAccount]="parentAccount"></app-account-list>
</section>
